const { trackGtm } = require('../../../../js/functions');

module.exports = {
	init() {
		const child = this.root.querySelector('a');

		child.addEventListener('click', () => {
			trackGtm({
				eventCategory: 'cta',
				eventAction: 'image',
				eventLabel: child.href,
			});
		});
	},
};
